import React from "react";
import "./src/styles/global.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StateProvider } from "./src/context/StateContext";

export const wrapPageElement = ({ element }) => {
    return <StateProvider>{element}</StateProvider>
  };